
import { Injectable } from '@angular/core';
import { ScoutPoint, ScoutPointError, ScoutPointHorizontalError, ScoutPointVerticalError } from '../models/scout-task';



@Injectable({ providedIn: 'root' })
export class ErrorCalculationService {

    //TODO--make these default values, allow override
    readonly HorizontalDistanceImplError = 0.02 // 2cm
    readonly ExternalWallDerivedAngleError = 0.5 //degrees
    readonly MeasuredAngleError = 1.0 //degrees

    readonly ExternalWallDerivedAngleErrorTangent = this.tan( this.ExternalWallDerivedAngleError )
    readonly MeasuredAngleErrorTangent = this.tan( this.MeasuredAngleError )

    readonly VerticalFloorVarianceBaseline = 0.02 // 2cm
    readonly VerticalFloorVarianceSignificant = 0.05 // 5cm
    readonly VerticalDistanceImplError = 0.02 // 2cm


    newHorizontalError() {
        let e = new ScoutPointHorizontalError()
        e.implConstant = this.HorizontalDistanceImplError
        e.externalWallAngleConstant = this.ExternalWallDerivedAngleError
        e.measuredAngleConstant = this.MeasuredAngleError
        e.externalWallAngleEstimate = 0
        e.measuredAngleEstimate = 0
        e.cumulativeEstimate = 0
        e.segmentEstimate = 0
        return e
    }


    newVerticalError() {
        let e = new ScoutPointVerticalError()
        e.implConstant = this.VerticalDistanceImplError
        e.unlevelFloorConstant = this.VerticalFloorVarianceSignificant
        e.floorVarianceConstant = this.VerticalFloorVarianceBaseline
        return e
    }


    isValid( errorObj : ScoutPointError) {
        //TBD - could check all constants
        return errorObj && errorObj.implConstant !== undefined
    }
    

    tan( angleDegrees ) {
        const radians = angleDegrees * Math.PI / 180
        return Math.tan( radians )
    }


    computeHorizontalError( horizontalError: ScoutPointHorizontalError, 
            measuredDistance : number, horizontalErrAcc : number  ) {
        horizontalError.implEstimate = horizontalError.implConstant
        horizontalError.externalWallAngleEstimate = measuredDistance * this.tan(horizontalError.externalWallAngleConstant)
        horizontalError.measuredAngleEstimate = horizontalError.derivedFromExternalWall ? 0 : measuredDistance * this.tan(horizontalError.measuredAngleConstant)
        horizontalError.segmentEstimate = horizontalError.implConstant + horizontalError.measuredAngleEstimate + horizontalError.externalWallAngleEstimate
        horizontalError.cumulativeEstimate = horizontalErrAcc + horizontalError.segmentEstimate
        return horizontalError
    }

    
    computeVerticalError( pt: ScoutPoint, heightOffset: number, vertErrAcc : number ) {
        let verticalError = pt.verticalError
        if ( pt.type == 'HA' ) {
            verticalError.implEstimate = verticalError.implConstant
            verticalError.floorVarianceEstimate = 0
            verticalError.unlevelFloorEstimate = 0
        } else {
            verticalError.implEstimate = heightOffset ? verticalError.implConstant : 0
            verticalError.floorVarianceEstimate = verticalError.floorVarianceConstant
            verticalError.unlevelFloorEstimate = verticalError.unlevelFloor ? verticalError.unlevelFloorConstant : 0
        }
        verticalError.segmentEstimate = verticalError.implEstimate + verticalError.floorVarianceEstimate + verticalError.unlevelFloorEstimate
        verticalError.cumulativeEstimate = vertErrAcc + verticalError.segmentEstimate
        return verticalError
    }
}